import React, { useCallback, useEffect, useState } from "react";
import { Box, styled } from "@mui/material";
import { useAppDispatch } from "../../redux/store";
import { getUserInfoThunk } from "../../redux/thunks/user.thunk";
import DashboardFrame from "../../component/dashboard-frame";
import { IWithClassName } from "../../theme/default.theme";
import { setCampaignListFiltersThunk, updateCampaignStatusThunk } from "../../redux/thunks/campaign.thunk";
import CampaignTable from "./campaign-table";
import Metric from "./metrics";
import DateRange from "./date-range-filter";
import { ICampaignFiltersDto } from "../../interfaces/dto/campaign.dto";
import { CampaignStatus } from "../../enum/campaign";
import { IDateRange } from "../../interfaces/campaign";
import dayjs from "dayjs";

const Page = ({ className }: IWithClassName) => {
  const dispatch = useAppDispatch();
  const [campaignfilters, setCampaignFilters] =
    useState<ICampaignFiltersDto>({
      offset: 0,
      limit: 10,
      startDate: dayjs().subtract(1, "day").format("YYYY-MM-DD"),
      endDate: dayjs().format("YYYY-MM-DD"),
      expand: "userId",
    });

  useEffect(() => {
    dispatch(getUserInfoThunk());
  }, [dispatch]);

  useEffect(() => {
    dispatch(setCampaignListFiltersThunk(campaignfilters));
  }, [dispatch, campaignfilters]);

  const dateChangeHandler = useCallback((dateRange: IDateRange) => {
    setCampaignFilters((filter) => ({
      ...filter,
      startDate: dateRange.startDate,
      endDate: dateRange.endDate,
    }));
  }, [setCampaignFilters]);

  const fetchCampaigns = useCallback((campaignListfilters: ICampaignFiltersDto) => {
    setCampaignFilters((filter) => ({
      ...filter,
      ...campaignListfilters,
      status: campaignListfilters.status === CampaignStatus.All ? undefined : campaignListfilters.status
    }));
  }, [setCampaignFilters]);

  const onStatusChange = async (id: string, status: CampaignStatus, campaignListfilters: ICampaignFiltersDto) => {
    const statusResult = await dispatch(updateCampaignStatusThunk(id, status));

    if (statusResult) {
      dispatch(setCampaignListFiltersThunk(campaignListfilters));
    }
  };

  return (
    <DashboardFrame title="Dashboard">
      <Box className={className}>
        <DateRange dateHandler={dateChangeHandler} />
        <Metric />
        <CampaignTable fetchCampaigns={fetchCampaigns} onStatusChange={onStatusChange}/>
      </Box>
    </DashboardFrame>
  );
};

export default styled(Page)(() => ({
  display: "grid",
  gap: 10,
}));
